import { applyAttributionToAnalytics } from './apply-attribution-to-analytics';
import { parseCurrentAttribution } from './parse-current-attribution';
import { readAttributionFromCookie } from './read-attribution-from-cookie';
import { saveAttributionToCookie } from './save-attribution-to-cookie';

export function captureAttribution(): void {
  const existing = readAttributionFromCookie();
  const touchKind = existing ? 'last' : 'first';
  const current = parseCurrentAttribution(touchKind);
  if (!current) {
    return;
  }
  saveAttributionToCookie(current);
  applyAttributionToAnalytics(current);
}
